import { render, staticRenderFns } from "./ModelPerformance.vue?vue&type=template&id=028171ff&scoped=true&"
import script from "./ModelPerformance.vue?vue&type=script&lang=js&"
export * from "./ModelPerformance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028171ff",
  null
  
)

export default component.exports